import { adminApi } from '@client/auth';

export function updateCountryFilter(countryCodes) {
  return adminApi.put('/admin/country-filter', { countryCodes });
}
